import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import Box from '@material-ui/core/Box';
import CircleLoader from '@invitation-homes/styled-ui/lib/components/Loader/CircleLoader';

import captureUnitId from '../utils/capture-unit-id';
import UnitAddress from '../components/UnitAddress';
import ErrorMessage from '../components/ErrorMessage';
import SelfShowingLayout from '../layouts/SelfShowing';
import EnsureAuthenticated from '../containers/EnsureAuthenticated';
import EnsureTrusted from '../containers/EnsureTrusted';
import ScheduleShowingPublicBooking from '../containers/ScheduleShowingPublicBooking';
import { readSelectedSlot } from '../services/scheduling-journey';
import getCanonicalRouteUnitId from '../utils/canonical-route-unit-id';

function captureCanonicalUnitId(props) {
  const routeUnitId = getCanonicalRouteUnitId(props.match?.params?.unit_id);
  if (!routeUnitId) return null;

  const capturedUnitId = captureUnitId(props);
  return String(capturedUnitId) === routeUnitId ? capturedUnitId : null;
}

export function BookShowingLoading() {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="90vh"
      role="status"
      aria-label="Loading tour details"
    >
      <CircleLoader size={24} />
    </Box>
  );
}

export class BookShowing extends Component {
  constructor(props) {
    super(props);
    this.unitId = captureCanonicalUnitId(props);
    this.selectedSlot = this.unitId ? readSelectedSlot(String(this.unitId)) : { valid: false, startUtc: null };
  }

  redirectStarted = false;

  redirectToSchedule = () => {
    if (this.redirectStarted) return;
    this.redirectStarted = true;
    this.props.history.replace(this.unitId ? `/schedule-showing/${this.unitId}` : '/homes');
  };

  renderBooking = ({ unit, unitAddress, error }) => {
    const loadingFallback = <BookShowingLoading />;

    if (!unitAddress && !error) {
      return loadingFallback;
    }

    if (error) {
      return (
        <SelfShowingLayout px={[20, 30, 60]} py={40}>
          <ErrorMessage type="ERR_UNIT_NOT_AVAILABLE" unitId={{ unit_id: this.unitId }} />
        </SelfShowingLayout>
      );
    }

    return (
      <EnsureAuthenticated
        pathName="/login"
        redirectTo="schedule a showing"
        redirectFor={unitAddress}
        verificationRequired={['email', 'phone', 'first_name', 'last_name']}
        loadingFallback={loadingFallback}
      >
        <EnsureTrusted unit={unit} loadingFallback={loadingFallback}>
          <SelfShowingLayout px={[20, 30, 60]} py={40}>
            <ScheduleShowingPublicBooking
              unitId={String(this.unitId)}
              unitAddress={unitAddress}
              unitState={unit.state}
              selectedStartUtc={this.selectedSlot.startUtc}
              history={this.props.history}
            />
          </SelfShowingLayout>
        </EnsureTrusted>
      </EnsureAuthenticated>
    );
  };

  render() {
    if (!this.selectedSlot.valid) {
      this.redirectToSchedule();
      return null;
    }

    return <UnitAddress unitId={this.unitId}>{this.renderBooking}</UnitAddress>;
  }
}

export default withRouter(BookShowing);
